import store from 'store';
import { pick, isEmpty } from 'lodash';

const KEY = 'member';

const ALLOWED_KEYS = [
  'hasSetCookie',
  'memberId',
  'voomeProductId',
  'redirectTo',
  'mealPlanHelpModal',
  'mealPlanWelcomeModal',
];

const get = () => {
  return store.get(KEY) || {};
};

const set = (obj, reset = false) => {
  let params = pick(obj, ALLOWED_KEYS);

  if (!isEmpty(params)) {
    if (!reset) {
      params = { ...get(), ...params };
    }

    store.set(KEY, params);
  }
};

const setKey = (key, value) => {
  if (ALLOWED_KEYS.indexOf(key) >= 0) {
    set({ [key]: value });
  }
};

const remove = () => {
  const {
    hasSetCookie,
    voomeProductId,
    mealPlanHelpModal,
    mealPlanWelcomeModal,
  } = get();
  set(
    { hasSetCookie, voomeProductId, mealPlanHelpModal, mealPlanWelcomeModal },
    true
  );
};

export const memberStorage = {
  get,
  set,
  setKey,
  remove,
};



// WEBPACK FOOTER //
// ./src/utils/memberStorage.js